import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InfinityScrollComponent } from '@app-components/common/infinity-scroll/infinity-scroll.component';
import { TransformEmailListItemContract } from '@app-types/api/email';
import { DatePipe, NgClass } from '@angular/common';
import { MatCard, MatCardContent } from '@angular/material/card';
import { ReplyAllButtonComponent } from '@app-components/email/action-buttons/reply-all-button/reply-all-button.component';
import { ReplyButtonComponent } from '@app-components/email/action-buttons/reply-button/reply-button.component';
import { EmailActionsEnum } from '@app-types/enums/EmailActions';
import { FormatSemicolonPipe } from '@app-pipes/format-semicolon-pipe';
import { EmailState } from '@app-types/enums/email-state';
import { SendingStateButtonComponent } from '@app-components/email/action-buttons/sending-state-button/sending-state-button.component';
import { EMAIL_SENDING_STATE } from '@app-shared/constants/constants';
import { EmailSelectCheckboxComponent } from '@app-components/email/email-select-checkbox/email-select-checkbox.component';
import { EmailColumnsEnum } from '@app-types/enums/emailColumns';
import { EmailTagsComponent } from '@app-components/email/email-tags/email-tags.component';
import { EmailsService } from '@app-services/emails/emails.service';
import { EmailsScrollService } from '@app-services/emails/emails-scroll.service';
import { EmailGroupListComponent } from '@app-components/email/email-group-list/email-group-list.component';
import { ActionsService } from '@app-services/emails/button-actions/actions.service';
import { ActionsModalsService } from '@app-services/emails/button-actions/actions-modal.service';
import { ButtonActionsService } from '@app-services/emails/button-actions/button-actions.service';
import { EmailsPageStateService } from '@app-services/emails/emails-page-state.service';
import { StarButtonComponent } from '@app-components/email/action-buttons/star-button/star-button.component';
import { ArchiveStateCellComponent } from '@app-components/email/archive-state-cell/archive-state-cell.component';

@Component({
  selector: 'app-emails-mobile',
  templateUrl: './emails-mobile.component.html',
  styleUrls: ['./emails-mobile.component.scss'],
  imports: [
    TranslateModule,
    InfinityScrollComponent,
    NgClass,
    MatCard,
    MatCardContent,
    ReplyAllButtonComponent,
    ReplyButtonComponent,
    FormatSemicolonPipe,
    SendingStateButtonComponent,
    EmailSelectCheckboxComponent,
    DatePipe,
    EmailTagsComponent,
    EmailGroupListComponent,
    StarButtonComponent,
    ArchiveStateCellComponent,
  ],
})
export class EmailsMobileComponent implements OnInit, AfterViewInit {
  public actionsModals: ActionsModalsService;
  public actions: ActionsService;

  @Output() rightClick = new EventEmitter<{
    event: MouseEvent;
    email: TransformEmailListItemContract;
  }>();

  @ViewChild(InfinityScrollComponent) infinityScroll: InfinityScrollComponent;

  EmailActionsEnum = EmailActionsEnum;
  EmailColumnsEnum = EmailColumnsEnum;
  public emailStates = EmailState;
  public sendingIcons = EMAIL_SENDING_STATE;
  showSendingStateButton = false;

  constructor(
    protected emailsService: EmailsService,
    protected emailsScrollService: EmailsScrollService,
    protected buttonActionsService: ButtonActionsService,
    protected emailsPageStateService: EmailsPageStateService
  ) {
    this.actionsModals = buttonActionsService.actionsModals;
    this.actions = buttonActionsService.actions;
  }

  ngOnInit(): void {
    this.showSendingStateButton =
      this.emailsPageStateService.displayedColumns.includes(
        EmailColumnsEnum.State
      );
  }

  get countTo(): number {
    return this.emailsPageStateService.dataSource.data.length;
  }

  ngAfterViewInit(): void {
    this.emailsScrollService.emailsMobileInfinityScroll = this.infinityScroll;
  }
}
